export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0" style={{ width: '100%', height: '100%' }}>
        <img
          src="https://public.readdy.ai/ai/img_res/f101cfd917de5a091d5f1fac1d44559d.jpg"
          alt="Background"
          className="w-full h-full object-cover object-center"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-gray-900/70 via-gray-900/60 to-gray-900/70"></div>

      <div className="relative z-10 max-w-6xl mx-auto px-6 py-32 text-center">
        <h1 className="text-3xl md:text-6xl lg:text-7xl font-bold text-white mb-8 leading-tight drop-shadow-2xl">
          住宅費を&quot;自腹&quot;で<br className="hidden md:block" />払わないでください！！
        </h1>

        <div className="mb-12">
          <p className="text-base md:text-2xl text-white leading-relaxed drop-shadow-lg font-medium mb-4">
            住宅費は「削減できないもの」だと思っていませんか？
          </p>
          <p className="text-base md:text-2xl text-white leading-relaxed drop-shadow-lg font-medium mb-4">
            給料も、貯金も削らずに、<br className="hidden md:block" />
            家賃・住宅ローンをほぼ無料にする方法があるとしたら――
          </p>
          <p className="text-base md:text-2xl text-white leading-relaxed drop-shadow-lg font-medium">
            知りたくありませんか？
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
          <a
            href="https://form.run/@yachinzero"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-gradient-to-r from-amber-500 to-amber-600 text-white px-8 md:px-12 py-4 md:py-6 rounded-lg text-base md:text-xl font-bold hover:from-amber-600 hover:to-amber-700 transition-all transform hover:scale-105 shadow-2xl cursor-pointer border-2 border-white/20 w-full sm:w-auto inline-flex items-center justify-center gap-3 whitespace-nowrap"
          >
            <i className="ri-calendar-check-line text-2xl"></i>
            個別面談に申し込む
          </a>
        </div>
      </div>
    </section>
  );
}